import React from 'react';
import {Route, useNavigate} from 'react-router-dom';
import ResetPassword from "./ResetPassword/ResetPassword";
import ForgotPassword from "./Forgot Password/ForgotPassword";
import './Auth.css'
import Login from "./login/Login.js";
import Register from "./register/Register.js";
import TwoFactorVerify from "./TwoFactorVerify/TwoFactorVerify.jsx";
import SessionExpired from "./session-expired/SessionExpired.jsx";
import AuthLayout from "../../components/AuthLayout.jsx";
import VerifyEmail from "./VerifyEmail/VerifyEmail.jsx";
import VerifyEmailCode from "./VerifyEmailCode/VerifyEmailCode.jsx";
import AuthCallback from "./AuthCallback/AuthCallback.jsx";

const AuthRoutes = ( ) => {
    const navigate = useNavigate();

    return (
        <>
            <Route
                path="/login"

                element={
                    <AuthLayout>
                        <Login
                            navigate={navigate}
                        />
                    </AuthLayout>
                }
            />

            <Route
                path="/session-expired"
                element={
                    <AuthLayout>
                        <SessionExpired/>
                    </AuthLayout>
                }
            />

            <Route
                path="/register"
                element={
                    <AuthLayout>
                        <Register
                            navigate={navigate}
                        />
                    </AuthLayout>
                }
            />

            <Route
                path="/reset-password/:token"
                element={
                    <AuthLayout>
                        <ResetPassword
                            navigate={navigate}
                        />
                    </AuthLayout>
                }
            />

            <Route
                path="/forgot-password"
                element={
                    <AuthLayout>
                        <ForgotPassword
                            navigate={navigate}
                        />
                    </AuthLayout>
                }
            />

            <Route
                path="/verify-email-code"
                element={
                    <AuthLayout>
                        <VerifyEmailCode />
                    </AuthLayout>
                }
            />

            <Route
                path="/verify-email"
                element={
                    <AuthLayout>
                        <VerifyEmail />
                    </AuthLayout>
                }
            />

            <Route
                path="/2fa-verify"
                element={
                    <AuthLayout>
                        <TwoFactorVerify/>
                    </AuthLayout>
                }
            />

            <Route
                path="/auth/callback"
                element={
                    <AuthLayout>
                        <AuthCallback />
                    </AuthLayout>
                }
            />

        </>
    );
};

export default AuthRoutes;
